(() => {
  const root = document.querySelector('[data-kingdom-id-customizer]');
  if (!root) return;

  const config = JSON.parse(root.querySelector('[data-kingdom-id-config]').textContent);
  const form = root.closest('form');
  const front = root.querySelector('[data-id-front]');
  const back = root.querySelector('[data-id-back]');
  const nameInput = root.querySelector('[data-id-name]');
  const birthInput = root.querySelector('[data-id-birth]');
  const photoInput = root.querySelector('[data-id-photo]');
  const photoGroup = root.querySelector('[data-id-photo-group]');
  const feedback = root.querySelector('[data-id-feedback]');
  const zoomInput = root.querySelector('[data-id-zoom]');
  const cropInput = root.querySelector('[data-id-crop]');
  const printFront = root.querySelector('[data-id-print-front]');
  const printBack = root.querySelector('[data-id-print-back]');
  const selected = form.querySelector('input[name="id"]');
  const cache = new Map();
  const fontsReady = Promise.all([
    document.fonts.load('56px "Kingdom Medieval"'),
    document.fonts.load('30px "Kingdom Mono Bold"'),
    document.fonts.load('78px "Kingdom Signature"')
  ]).catch(() => null);
  const colors = { '8a': '#E9E1CF', '8b': '#E9E1CF', '8c': '#F1E4C4', '8d': '#E9E1CF', '8e': '#1C1B1A' };
  const photoBoxes = {
    '8a': { x: 58, y: 182, w: 248, h: 318, shape: 'rect', stroke: '#E9E1CF' },
    '8b': { x: 712, y: 50, w: 248, h: 320, shape: 'arch', stroke: '#E9E1CF' },
    '8c': { x: 74, y: 185, w: 260, h: 260, shape: 'circle', stroke: '#D9B45E' },
    '8d': { x: 62, y: 352, w: 186, h: 228, shape: 'rect', stroke: '#E9E1CF' },
    '8e': { x: 50, y: 152, w: 246, h: 306, shape: 'rect', stroke: '#1C1B1A' }
  };
  let uploadedImage = null;
  let panX = 0;
  let panY = 0;
  let mode = 'front';
  let dragStart = null;
  let currentKey = '';
  let preparing = false;

  function variant() {
    const checkedStyle = document.querySelector('variant-selects input[type="radio"]:checked');
    return config.variants.find(item => item.title === checkedStyle?.value)
      || config.variants.find(item => item.id === selected.value)
      || config.variants[0];
  }

  function design() {
    const title = variant().title.replace(/ PHOTO ID$/i, '');
    return ({
      'Gnome World Order Initiate': '8a',
      'Mount Pilchuck Liberation': '8b',
      'Theocratic Monarchy': '8c',
      'Iron Wordmark': '8d',
      'National ID · Be Good to Yourself and Others': '8e'
    })[title] || '8a';
  }

  function withPhoto() {
    return /PHOTO ID/i.test(variant().title);
  }

  function loadImage(url) {
    if (!cache.has(url)) {
      cache.set(url, new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
      }));
    }
    return cache.get(url);
  }

  function fittedText(ctx, text, x, y, max, size, family, color, centered = false) {
    ctx.fillStyle = color;
    ctx.textBaseline = 'top';
    ctx.textAlign = centered ? 'center' : 'left';
    let scale = size;
    do {
      ctx.font = `${scale}px "${family}"`;
      if (ctx.measureText(text).width <= max) break;
      scale -= 2;
    } while (scale >= 25);
    ctx.fillText(text, x, y, max);
  }

  function drawPhoto(ctx, key) {
    if (!uploadedImage) return;
    const box = photoBoxes[key];
    const { x, y, w, h, shape } = box;
    ctx.save();
    ctx.beginPath();
    if (shape === 'circle') ctx.arc(x + w / 2, y + h / 2, w / 2 - 5, 0, Math.PI * 2);
    else if (shape === 'arch') {
      const r = w / 2 - 3;
      ctx.moveTo(x + 3, y + h - 3);
      ctx.lineTo(x + 3, y + r + 3);
      ctx.arc(x + w / 2, y + r + 3, r, Math.PI, 0);
      ctx.lineTo(x + w - 3, y + h - 3);
      ctx.closePath();
    } else ctx.rect(x + 3, y + 3, w - 6, h - 6);
    ctx.clip();
    const zoom = Number(zoomInput.value);
    const ratio = Math.max(w / uploadedImage.width, h / uploadedImage.height) * zoom;
    const drawW = uploadedImage.width * ratio;
    const drawH = uploadedImage.height * ratio;
    ctx.drawImage(uploadedImage, x + (w - drawW) / 2 + panX, y + (h - drawH) / 2 + panY, drawW, drawH);
    ctx.restore();
    ctx.save();
    ctx.strokeStyle = box.stroke;
    ctx.lineWidth = shape === 'circle' ? 4 : 2;
    ctx.beginPath();
    if (shape === 'circle') ctx.arc(x + w / 2, y + h / 2, w / 2 - 2, 0, Math.PI * 2);
    else if (shape === 'arch') {
      ctx.moveTo(x, y + h);
      ctx.lineTo(x, y + w / 2);
      ctx.arc(x + w / 2, y + w / 2, w / 2, Math.PI, 0);
      ctx.lineTo(x + w, y + h);
    } else ctx.rect(x, y, w, h);
    ctx.stroke();
    ctx.restore();
  }

  function drawFront(ctx, key, name, dob) {
    const color = colors[key];
    if (withPhoto()) drawPhoto(ctx, key);
    const settings = {
      '8a': { x: 346, nameY: 198, size: 56, max: 585, dobX: 346, speciesX: 600, valuesY: 317, rowSize: 30 },
      '8b': { x: 56, nameY: 229, size: 54, max: 615, dobX: 56, speciesX: 374, valuesY: 338, rowSize: 28 },
      '8c': { x: 400, nameY: 300, size: 52, max: 550, dobX: 400, speciesX: 688, valuesY: 402, rowSize: 26 },
      '8d': withPhoto()
        ? { x: 290, nameY: 379, size: 54, max: 645, dobX: 290, speciesX: 502, valuesY: 559, rowSize: 22 }
        : { x: 510, nameY: 379, size: 66, max: 870, dobX: 228, speciesX: 438, valuesY: 559, rowSize: 22, centered: true },
      '8e': { x: 336, nameY: 183, size: 54, max: 630, dobX: 336, speciesX: 667, valuesY: 296, rowSize: 30 }
    }[key];
    fittedText(ctx, name, settings.x, settings.nameY, settings.max, settings.size, 'Kingdom Medieval', color, settings.centered);
    fittedText(ctx, dob, settings.dobX, settings.valuesY, 300, settings.rowSize, 'Kingdom Mono Bold', color);
    fittedText(ctx, 'Human', settings.speciesX, settings.valuesY, 240, settings.rowSize, 'Kingdom Mono Bold', color);
  }

  function drawBack(ctx, key, name) {
    if (!name) return;
    const signatureY = key === '8a' ? 470 : key === '8e' ? 446 : 465;
    const signatureX = key === '8e' ? 80 : 62;
    ctx.save();
    ctx.translate(signatureX, signatureY);
    ctx.rotate(-4 * Math.PI / 180);
    fittedText(ctx, name, 0, 0, key === '8e' ? 520 : 610, 78, 'Kingdom Signature', key === '8b' ? '#1F3A2C' : colors[key]);
    ctx.restore();
  }

  async function render() {
    const chosen = variant();
    selected.value = chosen.id;
    currentKey = chosen.id;
    const key = design();
    photoGroup.hidden = !withPhoto();
    photoInput.required = withPhoto();
    photoInput.disabled = !withPhoto();
    cropInput.value = withPhoto() ? JSON.stringify({offsetX: Math.round(panX), offsetY: Math.round(panY), zoom: Number(zoomInput.value)}) : '';
    const assets = config.designs[key];
    const name = nameInput.value.trim();
    const dob = birthInput.value ? birthInput.value.split('-').slice(1).concat(birthInput.value.slice(0, 4)).join('/') : '';
    const frontImage = await loadImage(withPhoto() ? assets.photo : assets.noPhoto);
    const backImage = await loadImage(assets.back);
    await fontsReady;
    if (key !== design()) return;
    const frontCtx = front.getContext('2d');
    frontCtx.clearRect(0, 0, 1020, 630);
    frontCtx.drawImage(frontImage, 0, 0, 1020, 630);
    drawFront(frontCtx, key, name, dob);
    const backCtx = back.getContext('2d');
    backCtx.clearRect(0, 0, 1020, 630);
    backCtx.drawImage(backImage, 0, 0, 1020, 630);
    drawBack(backCtx, key, name);
  }

  function setMode(next) {
    mode = next;
    front.hidden = next !== 'front';
    back.hidden = next !== 'back';
    for (const button of root.querySelectorAll('[data-id-side]')) {
      button.setAttribute('aria-pressed', String(button.dataset.idSide === next));
    }
  }

  function canvasFile(canvas, filename) {
    return new Promise((resolve, reject) => {
      try {
        canvas.toBlob(blob => blob ? resolve(new File([blob], filename, { type: 'image/png' })) : reject(new Error('Could not export card artwork.')), 'image/png');
      } catch (error) {
        reject(error);
      }
    });
  }

  function putFile(input, file) {
    const transfer = new DataTransfer();
    transfer.items.add(file);
    input.files = transfer.files;
  }

  root.querySelectorAll('[data-id-side]').forEach(button => button.addEventListener('click', () => setMode(button.dataset.idSide)));
  nameInput.addEventListener('input', render);
  birthInput.addEventListener('input', render);
  zoomInput.addEventListener('input', render);
  photoInput.addEventListener('change', async () => {
    const file = photoInput.files[0];
    if (!file) { uploadedImage = null; render(); return; }
    if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type) || file.size > 15 * 1024 * 1024) {
      feedback.textContent = 'Choose a JPG, PNG, or WebP photo under 15 MB.';
      photoInput.value = '';
      uploadedImage = null;
      render();
      return;
    }
    try {
      uploadedImage = await createImageBitmap(file);
      panX = 0;
      panY = 0;
      zoomInput.value = '1';
      feedback.textContent = '';
      render();
    } catch {
      feedback.textContent = 'This photo could not be opened. Choose a JPG, PNG, or WebP image.';
      photoInput.value = '';
      uploadedImage = null;
    }
  });

  front.addEventListener('pointerdown', event => {
    if (!withPhoto() || !uploadedImage) return;
    dragStart = { x: event.clientX, y: event.clientY, px: panX, py: panY };
    front.setPointerCapture(event.pointerId);
  });
  front.addEventListener('pointermove', event => {
    if (!dragStart) return;
    const scale = 1020 / front.getBoundingClientRect().width;
    panX = dragStart.px + (event.clientX - dragStart.x) * scale;
    panY = dragStart.py + (event.clientY - dragStart.y) * scale;
    render();
  });
  front.addEventListener('pointerup', () => { dragStart = null; });
  front.addEventListener('pointercancel', () => { dragStart = null; });

  new MutationObserver(() => {
    if (currentKey === selected.value) return;
    render();
  }).observe(selected, { attributes: true, attributeFilter: ['value'] });
  document.addEventListener('change', () => setTimeout(render, 0));
  form.addEventListener('submit', async event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (preparing) return;
    feedback.textContent = '';
    if (!nameInput.value.trim() || !birthInput.value || (withPhoto() && !photoInput.files[0])) {
      feedback.textContent = 'Enter a name and date of birth, and add a photo for a photo ID.';
      feedback.focus();
      return;
    }
    if (nameInput.value.trim().length > 40) {
      feedback.textContent = 'Use 40 characters or fewer for the name.';
      feedback.focus();
      return;
    }
    if (birthInput.value > new Date().toISOString().slice(0, 10)) {
      feedback.textContent = 'Enter a date of birth that is not in the future.';
      feedback.focus();
      return;
    }
    preparing = true;
    feedback.textContent = 'Preparing your card artwork…';
    try {
      await render();
      const key = design();
      const [frontFile, backFile] = await Promise.all([
        canvasFile(front, `kingdom-citizen-${key}-front.png`),
        canvasFile(back, `kingdom-citizen-${key}-back.png`)
      ]);
      putFile(printFront, frontFile);
      putFile(printBack, backFile);
      HTMLFormElement.prototype.submit.call(form);
    } catch (error) {
      feedback.textContent = 'The card artwork could not be prepared. Please try again or choose another photo.';
      feedback.focus();
      preparing = false;
    }
  }, true);

  document.fonts.ready.then(render);
  render();
})();
